import { motion } from 'framer-motion';

const clients = [
  {
    name: "TechFlow Solutions",
    logo: "https://public.readdy.ai/ai/img_res/27a70f0376c9cea5065aede53efaf110.jpg"
  },
  {
    name: "E-Commerce Pro",
    logo: "https://readdy.ai/api/search-image?query=ecommerce%20brand%20logo%20modern%20minimalist%20shopping%20icon%20professional%20clean%20design%20corporate%20identity%20retail%20business%20branding%20elegant%20simple&width=180&height=80&seq=client-logo-2&orientation=landscape"
  },
  {
    name: "Innovation Labs",
    logo: "https://readdy.ai/api/search-image?query=innovation%20lab%20logo%20futuristic%20abstract%20geometric%20modern%20professional%20clean%20corporate%20identity%20technology%20research%20branding%20minimalist%20elegant&width=180&height=80&seq=client-logo-3&orientation=landscape"
  },
  {
    name: "Digital Marketing Agency",
    logo: "https://readdy.ai/api/search-image?query=digital%20marketing%20agency%20logo%20creative%20modern%20abstract%20design%20professional%20clean%20corporate%20identity%20advertising%20branding%20minimalist%20elegant%20simple&width=180&height=80&seq=client-logo-4&orientation=landscape"
  },
  {
    name: "HealthCare Plus",
    logo: "https://readdy.ai/api/search-image?query=healthcare%20medical%20company%20logo%20modern%20minimalist%20cross%20heart%20icon%20professional%20clean%20design%20corporate%20identity%20wellness%20branding%20elegant%20simple&width=180&height=80&seq=client-logo-5&orientation=landscape"
  },
  {
    name: "Finance Solutions",
    logo: "https://readdy.ai/api/search-image?query=finance%20banking%20company%20logo%20modern%20minimalist%20geometric%20abstract%20design%20professional%20clean%20corporate%20identity%20financial%20services%20branding%20elegant%20simple&width=180&height=80&seq=client-logo-6&orientation=landscape"
  },
  {
    name: "Real Estate Group",
    logo: "https://readdy.ai/api/search-image?query=real%20estate%20company%20logo%20modern%20minimalist%20building%20house%20icon%20professional%20clean%20design%20corporate%20identity%20property%20branding%20elegant%20simple&width=180&height=80&seq=client-logo-7&orientation=landscape"
  },
  {
    name: "Education Platform",
    logo: "https://readdy.ai/api/search-image?query=education%20learning%20platform%20logo%20modern%20minimalist%20book%20graduation%20cap%20icon%20professional%20clean%20design%20corporate%20identity%20elearning%20branding%20elegant%20simple&width=180&height=80&seq=client-logo-8&orientation=landscape"
  },
  {
    name: "Food Delivery",
    logo: "https://readdy.ai/api/search-image?query=food%20delivery%20service%20logo%20modern%20minimalist%20fork%20spoon%20icon%20professional%20clean%20design%20corporate%20identity%20restaurant%20branding%20elegant%20simple&width=180&height=80&seq=client-logo-9&orientation=landscape"
  },
  {
    name: "Travel Agency",
    logo: "https://readdy.ai/api/search-image?query=travel%20tourism%20agency%20logo%20modern%20minimalist%20airplane%20globe%20icon%20professional%20clean%20design%20corporate%20identity%20vacation%20branding%20elegant%20simple&width=180&height=80&seq=client-logo-10&orientation=landscape"
  },
  {
    name: "Fashion Retail",
    logo: "https://readdy.ai/api/search-image?query=fashion%20retail%20brand%20logo%20modern%20minimalist%20elegant%20abstract%20design%20professional%20clean%20corporate%20identity%20clothing%20store%20branding%20luxury%20simple&width=180&height=80&seq=client-logo-11&orientation=landscape"
  },
  {
    name: "Automotive Group",
    logo: "https://readdy.ai/api/search-image?query=automotive%20car%20company%20logo%20modern%20minimalist%20vehicle%20icon%20professional%20clean%20design%20corporate%20identity%20transportation%20branding%20elegant%20simple&width=180&height=80&seq=client-logo-12&orientation=landscape"
  }
];

export default function ClientLogos() {
  return (
    <section className="py-20 bg-gradient-to-b from-black to-gray-950 relative overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-r from-cyber-blue/5 via-transparent to-[#39FF14]/5"></div>
      
      <div className="relative max-w-7xl mx-auto px-6">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-center mb-16"
        >
          <h2 className="text-4xl lg:text-5xl font-display font-bold text-white mb-4">
            Ils Nous Font Confiance
          </h2>
          <p className="text-lg text-gray-400 font-body">
            Plus de 500 entreprises utilisent nos Agents IA pour transformer leur business
          </p>
        </motion.div>

        {/* Logos Grid */}
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-8 lg:gap-12">
          {clients.map((client, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, scale: 0.8 }}
              whileInView={{ opacity: 1, scale: 1 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: index * 0.05 }}
              className="group flex items-center justify-center p-6 bg-white/5 backdrop-blur-sm rounded-2xl border border-white/10 hover:border-white/20 hover:bg-white/10 transition-all cursor-pointer"
            >
              <div className="w-full h-16 flex items-center justify-center">
                <img
                  src={client.logo}
                  alt={client.name}
                  className="w-full h-full object-contain grayscale group-hover:grayscale-0 opacity-60 group-hover:opacity-100 transition-all duration-500"
                />
              </div>
            </motion.div>
          ))}
        </div>

        {/* Trust Badge */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ delay: 0.3 }}
          className="mt-16 text-center"
        >
          <div className="inline-flex items-center gap-3 px-6 py-3 bg-gradient-to-r from-cyber-blue/20 to-[#39FF14]/20 backdrop-blur-sm rounded-full border border-white/10">
            <i className="ri-shield-check-line text-2xl text-cyber-blue"></i>
            <span className="text-white font-body text-sm">
              <strong className="font-display">500+ entreprises</strong> nous font confiance pour automatiser leurs processus
            </span>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
